module.exports = __webpack_public_path__ + "img/(9).c6f8fac1.jpg";